import { OfferProgramTermsViewNewNav } from "views/OfferProgramTerms";
import { PlatformApp } from "@platform/cj-platform-navigation";
import translations from "translations";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { UserContextType, UserProvider } from "context/UserContext";
import { OfferProgramTermsViewProvider } from "views/OfferProgramTerms/context/OfferProgramTermsViewProvider";
import { Authorization } from "components/Authorization";
import {
  isAdvertiserUser,
  currentCompanyMatchesQueryParam,
  allOf,
  isSuperUserOrOperator
} from "components/Authorization/authorizers";
import { isProduction } from "../config";
import { RelationshipStatusesProvider } from "context";
import messages from "./messages";
import { ErrorPage } from "@cjdev-internal/visual-stack-x/components/ErrorPage";

export const AppWithNav = () => {
  const routes = [
    {
      path: "offer-program-terms",
      titleMessage: { ...messages.offerProgamTerms },
      layout: {
        filters: false,
        sidenav: false,
        dimensions: false,
      },
      Content: (user: UserContextType) => {
        return (
          <UserProvider user={user.user}>
            <Authorization
              authorizer={allOf([isAdvertiserUser, isSuperUserOrOperator, currentCompanyMatchesQueryParam])}
            >
              <RelationshipStatusesProvider>
                <OfferProgramTermsViewProvider>
                  {false && <ReactQueryDevtools initialIsOpen={false} />}
                  <OfferProgramTermsViewNewNav />
                </OfferProgramTermsViewProvider>
              </RelationshipStatusesProvider>
            </Authorization>
          </UserProvider>
        );
      },
    },
    {
      path: "*",
      titleMessage: { ...messages.pageNotFound },
      layout: {
        filters: false,
        sidenav: false,
        dimensions: false,
      },
      Content: () => <ErrorPage errorCode={404} />,
    },
  ];
  // the bare minimum, other domains will be added if/when we ever incorporate
  // the full nav into this area
  const platformDomains = isProduction()
    ? undefined
    : {
        members: "lab106",
        iam: "dev"
      };
  return <PlatformApp platformDomains={platformDomains} routes={routes} translations={translations} />;
};
